import React, { useState } from "react"
import { Link } from "gatsby"
import logo from "../assets/images/logo.png"
import { Nav, NavDropdown } from "react-bootstrap"
import { FaTimes } from "react-icons/fa"
import { FaBars } from "react-icons/fa"
import {
  FaFacebookSquare,
  FaInstagram,
  FaPhoneSquareAlt,
  FaSms,
} from "react-icons/fa"

const Header = () => {
  const [show, setShow] = useState(false)
  const [show2, setShow2] = useState(false)

  const [toggle, setToggle] = useState(false)

  const showDropdown = e => {
    setShow(!show)
  }
  const hideDropdown = e => {
    setShow(false)
  }
  const showDropdown2 = e => {
    setShow2(!show2)
  }
  const hideDropdown2 = e => {
    setShow2(false)
  }

  const handleToggle = () => setToggle(!toggle)

  return (
    <nav className="my-nav">
      <div className={`${toggle ? "hide-logo" : "show-logo"}`}>
        <Link to="/">
          <img src={logo} alt="logo" className="logo" />
        </Link>
      </div>
      <FaBars onClick={handleToggle} className="bars" />
      <div className={`${toggle ? "ul-items  show-sidebar" : "ul-items"}`}>
        <div className="nav-det">
          <img src={logo} alt="logo" className="nav-logo" />
          <FaTimes className="nav-bars" onClick={handleToggle} />
        </div>
        <div className="underline"></div>
        <FaTimes onClick={handleToggle} className="nav-bars" />
        <NavDropdown
          title="FOR STUDENTS"
          id="basic-nav-dropdown"
          onMouseEnter={showDropdown}
          onMouseLeave={hideDropdown}
          show={show}
          onClick={showDropdown}
        >
          <Link
            to="/finding-place"
            className="dropdown-item"
            activeClassName="style-links"
          >
            I'M FINDING AN APARTMENT
          </Link>
          <Link
            to="/listing-place"
            className="dropdown-item"
            activeClassName="style-links"
          >
            I'M LISTING AN APARTMENT
          </Link>
        </NavDropdown>
        <Link
          className="nav-link"
          to="/for-guarantors"
          activeClassName="style-links"
        >
          FOR GUARANTORS
        </Link>
        <NavDropdown
          title="RESOURCES"
          id="basic-nav-dropdown"
          onMouseEnter={showDropdown2}
          onMouseLeave={hideDropdown2}
          onClick={showDropdown2}
          show={show2}
        >
          <Link
            to="/faq"
            className="dropdown-item"
            activeClassName="style-links"
          >
            FAQ
          </Link>
          <Link
            to="/blog"
            className="dropdown-item"
            activeClassName="style-links"
          >
            BLOG
          </Link>
        </NavDropdown>
        <Link className="nav-link" to="/about" activeClassName="style-links">
          ABOUT US
        </Link>
        <Nav.Link href="#home">MARKETPLACE</Nav.Link>
        <Nav.Link href="#home" className="btn-nav">
          GET STARTED
        </Nav.Link>
        <Nav.Link className="nav-link" href="#home">
          LOG IN
        </Nav.Link>

        <div className="header-social">
          <a href="https://www.instagram.com/undorm/?hl=en">
            <FaInstagram className="social-icon3" />
          </a>
          <a href="https://www.facebook.com/undorm/">
            <FaFacebookSquare className="social-icon3" />
          </a>
          <a href="tel:(702) 339-1414">
            <FaPhoneSquareAlt className="social-icon3" />
          </a>
          <a href="sms:/(702) 339-1414/?body=/hello/">
            <FaSms className="social-icon3" />
          </a>
        </div>
      </div>
    </nav>
  )
}

export default Header
